<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存-多规格-表格

      author: dhx
      update: 2024-03-22
      describe: feat code
    -->
  <div class="mt16 many_table">
    <el-form-item label="规格明细：" v-if="form.model.spec_many && form.model.spec_many.spec_list.length > 0">
      <div class="setting-input d-s-c d-r">
        <el-input size="small" v-for="(item, index) in btnColumns" v-model="batchData[item.prop]"
          :placeholder="item.holder" :key="index">
        </el-input>

        <el-button size="small" @click="onSubmitBatchData">批量应用</el-button>
      </div>

      <!-- 提示 -->
      <el-alert style="margin-top: 10px;" title="提示" description="要实现租金的正常计算，期数是必要的（即带有'期数'名称的规格必须要有）" size="mini"
        type="info" show-icon></el-alert>

      <!--多规格表格-->
      <div>
        <el-table size="mini" :data="list" border v-loading="loading" :fit="true" :span-method="calculateSpan"
          style="margin-top: 20px;" :cell-class-name="setBgColor">
          <template v-for="(item, index) in Columns">
            <el-table-column v-if="item.click" :prop="item.prop" :label="item.label">
              <template slot-scope="{ row, $index }">
                <img v-img-url="row[item.prop]" alt="商品图片" width="35" height="35" @click="chooseImg($index)" />
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.input" :prop="item.prop" :label="item.label" width="100">
              <template slot-scope="{ row, $index }">
                <el-input class="hide_border" type="number" :rules:="[{ required: true, message: ' ' }]" size="mini"
                  v-model="row[item.prop]" @blur="handleBlur(row, item.prop, $index)"></el-input>
              </template>
            </el-table-column>

            <el-table-column v-else class="hide_border" :prop="item.prop" :label="item.label"></el-table-column>
          </template>
        </el-table>
      </div>
    </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isUpload" :isupload="isUpload" @returnImgs="imgCallback">上传图片</Upload>
    <el-dialog title="设置租期" :visible.sync="dialogVisiblexgsp" width="30%">
      <div class="d-c-c">
        <table border class="zhangdantable" style="width: 80%;">
          <tr>
            <th>期数</th>
            <th>租金</th>
          </tr>
          <tr v-for="(item, index) in indexList" :key="index">
            <td style="text-align: center">{{ item.period }}</td>
            <td>
              <el-input v-model="item.price" placeholder="请输入租金"></el-input>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button type="primary" @click="xgspqd()">确 定</el-button>
        <el-button @click="dialogVisiblexgsp = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Upload from "@/components/file/Upload";

const btnColumns = [
  { prop: "official_website_price", holder: "直售价" },
  { prop: "yield", holder: "收益率" },
  { prop: "buy_out_price", holder: "买断价" },
  { prop: "deposit", holder: "押金" },
  { prop: "stock_num", holder: "库存" },
  { prop: "product_weight", holder: "重量" },
  { prop: 'first_price', holder: '首期租金' },
];

const specColumns = [
  { prop: "image_path", label: "图片", click: true },
  { prop: "line_price", label: "总租金", input: true },
  { prop: "official_website_price", label: "直售价", input: true },
  { prop: "yield", label: "收益率", input: true },
  { prop: "first_price", label: "首期租金", input: false },
  // { prop: "product_price", label: "每日租金(元)", input: false },
  { prop: "produnt_period", label: "每期租金(元)", button: true },
  { prop: "buy_out_price", label: "买断价", input: true },
  { prop: "deposit", label: "押金", input: true },
  { prop: "stock_num", label: "库存", input: true },
  { prop: "product_weight", label: "重量(kg)", input: true }
];

/*批量设置sku属性*/
const batchData = {
  // product_price: "",
  produnt_period: "",
  line_price: "",
  yield: "",
  official_website_price: "",
  stock_num: "",
  product_weight: "",
  buy_out_price: "",
  deposit: ""
  // first_price: ""
};

const state = {
  loading: false,
  spec_many: null,
  lease_time: null,
  batchData,
  btnColumns,
  Columns: [...specColumns],
  list: [],
  spec: [],
  indexList: [],
  indexRow: "",
  indexKeys: ""
};

function MergeSpecific(env, list) {
  const defaultItem = {
    buy_out_price: "",
    deposit: "",
    image_id: "",
    image_path: "",
    line_price: "",
    yield: "",
    official_website_price: "",
    product_no: "",
    // product_price: "",
    product_weight: "",
    produnt_period: "",
    stock_num: "",
    supplier_price: ""
  };

  env.list = list.reduce((pre, { rows, spec_form: item }, index) => {
    pre.push({
      ...rows.map(i => i.spec_value),
      ...{ ...defaultItem, ...item }
    });
    return pre;
  }, []);
}

function mergeSpecification() {
  const { spec_list } = this.spec_many;
  return MergeSpecific(this, spec_list);
}

function calculateSpec() {
  const { spec_attr } = this.spec_many;

  let spec = [],
    value = 1;
  for (let i = spec_attr.length - 1; i >= 0; i--) {
    spec.push(value);
    value = value * spec_attr[i].spec_items.length;
  }

  spec.reverse();
  this.spec = spec;

  this.Columns = [
    ...spec_attr.map((v, i) => ({ prop: String(i), label: v.group_name })),
    ...specColumns
  ];
}

function getLeaseTime() {
  const { spec_attr } = this.spec_many;
  const index = spec_attr.findIndex(i => i.group_name.includes("期"));

  if (index < 0) return;

  const lease_time = spec_attr[index].spec_items.map(({ spec_value: v }) => v);
  this.lease_time = Object.freeze({ index, value: lease_time });
}

function calculateSpan({ rowIndex, columnIndex }) {
  const len = this.spec[columnIndex];

  if (!len) return { colspan: 1, rowspan: 1 };

  if (len && rowIndex % len === 0) return { colspan: 1, rowspan: len };
  return { colspan: 0, rowspan: 0 };
}
function onPeriod(row, prop, key) {
  console.log(row, prop, key, this.lease_time);
  let phase;
  for (let key in row) {
    if (this.lease_time.value.includes(row[key])) {
      console.log(key);
      phase = row[key];
    }
  }
  console.log(phase);
  this.indexRow = row;
  this.indexKeys = key;
  if (row.produnt_period !== "" && row.produnt_period.length == phase) {
    this.indexList = row.produnt_period.map((item, index) => {
      let obj = {
        period: index + 1,
        price: item
      };
      return obj;
    });
  } else {
    this.indexList = [];
    for (let index = 0; index < Number(phase); index++) {
      let obj = {
        period: index + 1,
        price: ""
      };
      this.indexList.push(obj);
    }
  }
  this.dialogVisiblexgsp = true;
  console.log(this.indexList);
}
function validatePrices() {
  for (let i = 0; i < this.indexList.length; i++) {
    if (this.indexList[i].price === "") {
      this.$message.error("每个价格都不能为空！");
      return false;
    }
  }
  let totalPrice = this.indexList.reduce(
    (sum, item) => sum + parseFloat(item.price),
    0
  );
  if (totalPrice !== parseFloat(this.indexRow.line_price)) {
    this.$message.error("所有每期租金和必须等于总租金！");
    return false;
  }
  return true;
}
function xgspqd() {
  let self = this;
  console.log(self.indexList);
  if (self.validatePrices()) {
    let prices = self.indexList.map(item => item.price);
    self.list[self.indexKeys].produnt_period = prices.map(p => Number(p));
    self.dialogVisiblexgsp = false;
    self.syncProductDetails();
  }
}
function handleBlur(row, prop, key) {
  console.log(row['produnt_period'], 'row["produnt_period"]')
  console.log(typeof row['produnt_period'], 'this.lease_time')
  if (this.lease_time == null) {
    this.$message.error("请添加带有'期'字名称的规格");
    return
  }
  let phase;
  for (let key in row) {
    if (this.lease_time.value.includes(row[key])) {
      phase = row[key];
    }
  }
  if (prop === "official_website_price" || prop === "yield") {
    if (row["yield"] && row["official_website_price"]) {
      let price1;
      if (row["yield"] >= 0) {
        price1 = row["yield"] * row["official_website_price"];
        console.log(price1, 'price1');
      } else {
        this.$message.error("请选择正确的收益率");
      }
      row["line_price"] = price1.toFixed(2);

      if (typeof row['produnt_period'] == Array) {
        const prices = row['produnt_period'];
        // 设置第一期租金为直售价的30%
        prices[0] = row["official_website_price"] * 0.3;
        console.log(prices[0], 'prices')
        // 计算剩余期数的租金
        const remainingPricess = ((row['official_website_price'] - prices[0]) * row['yield']) / (prices.length - 1);

        // 将剩余期数的租金都设置为remainingPricess
        for (let i = 1; i < prices.length; i++) {
          prices[i] = remainingPricess;
        }

        // 计算总租金（所有期数租金的总和）
        row['line_price'] = prices.reduce((sum, price) => sum + price, 0).toFixed(2);

        // 更新produnt_period，保留两位小数
        row['produnt_period'] = prices.map(p => Number(p.toFixed(2)));
      } else {
        // 创建新的数组，长度为this.lease_time.value[0]
        const periodCount = Number(this.lease_time.value[0]);
        const prices = new Array(periodCount);

        // 设置第一期租金为直售价的30%
        prices[0] = row["official_website_price"] * 0.3;
        console.log(prices, 'prices[0]')
        // 计算剩余期数的租金：(直售价 - 第一期租金) * 收益率 / (总期数 - 1)
        const remainingPricess = ((row['official_website_price'] - prices[0]) * row['yield']) / (periodCount - 1);

        // 填充剩余期数的租金
        for (let i = 1; i < periodCount; i++) {
          prices[i] = remainingPricess;
        }
        console.log(prices, 'prices[1]')

        // 计算总租金（所有期数租金的总和）
        row['line_price'] = prices.reduce((sum, price) => sum + price, 0).toFixed(2);

        // 更新produnt_period，保留两位小数
        const pricess = prices.map(p => Number(p.toFixed(2)));
        row['first_price'] = pricess[0];
        console.log(pricess, 'pricess')
        row['produnt_period'] = pricess[1];
      }
    }
  }
  const price = row["line_price"] / phase;
  this.syncProductDetails();

  return row;
}

function setBgColor({ columnIndex }) {
  return columnIndex < this.spec.length ? "bg-light-blue" : "";
}

function onSubmitBatchData() {
  // const self = this;
  // const batchData = { ...self.batchData };
  // console.log(batchData);
  // console.log(self.list);
  // self.list = self.list.map((item, index) =>
  //   handleBlur.call(
  //     self,
  //     { ...item, ...batchData },
  //     "official_website_price",
  //     index
  //   )
  // );
  const self = this;
  const batchData = { ...self.batchData };
  // 定义一个辅助函数来检查值是否为空
  function isEmptyValue(value) {
    return value === null || value === undefined || value === "";
  }
  // 更新列表，仅在batchData中的值非空时才覆盖item中的值
  self.list = self.list.map((item, index) => {
    // 使用reduce来构建新的对象，仅包含非空的batchData属性
    const updatedItem = Object.keys(batchData).reduce((acc, key) => {
      if (!isEmptyValue(batchData[key])) {
        // 如果batchData中的值非空，则将其添加到acc中
        acc[key] = batchData[key];
      }
      return acc;
    }, { ...item }
    ); // 初始值为item的副本
    // 现在调用handleBlur，传入更新后的item和其他参数
    return handleBlur.call(self, updatedItem, "official_website_price", index);
  });
}

function chooseImg(spec_index) {
  this.isUpload = true;
  this.spec_index = spec_index;
}

function imgCallback(e) {
  this.isUpload = false;

  const index = this.spec_index;
  const { file_id, file_path } = e[0];

  this.list[index].image_path = file_path;
  this.list[index]["image_id"] = file_id;

  this.syncProductDetails();
}

function handleProductDetails() {
  const self = this;

  const keys = [
    "buy_out_price",
    "deposit",
    "image_id",
    "image_path",
    "line_price",
    "yield",
    "official_website_price",
    "product_no",
    // "product_price",
    "product_weight",
    "first_price",
    "produnt_period",
    "stock_num",
    "supplier_price"
  ];

  self.spec_many.spec_list.map(({ spec_form: item }, index) => {
    const listItem = self.list[index];
    keys.map(key => {
      item[key] = listItem[key];
    });
  });

  setTimeout(() => (self.formStatus.loading = false), 0);
}

function debounce(fn) {
  let timeout = null;
  return function (...args) {
    const self = this;

    self.formStatus.loading = true;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.call(this, self);
    }, 300);
  };
}

const syncProductDetails = debounce(self => {
  self.handleProductDetails();
});

const syncSpecList = debounce(self => {
  self.init();
});

const watch = {
  "spec_many.spec_attr": {
    handler: function (newVal, oldVal) {
      this.syncSpecList();
    },
    deep: true,
    immediate: true // 该回调将会在侦听开始之后被立即调用
  }
};

function init() {
  const self = this;

  new Promise(resolve => {
    if (!self.spec_many.spec_attr) return resolve();
    self.calculateSpec();
    self.mergeSpecification();
    self.getLeaseTime();
    self.$forceUpdate();
    self.$nextTick(() => resolve());
  }).then(() => {
    self.formStatus.loading = false;
  });
}

export default {
  components: { Upload },
  data() {
    return {
      isUpload: false /*图片上传组件*/,
      spec_index: -1 /*规格下标*/,
      dialogVisiblexgsp: false,
      ...state
    };
  },
  inject: ["form", "formStatus"],

  // 组件初始化
  created: function () {
    this.spec_many = this.form.model.spec_many;
  },

  // 监听变化
  watch,

  methods: {
    init,

    // 设置背景颜色
    setBgColor,

    // 计算合并值
    calculateSpec,

    // 收集租期
    getLeaseTime,

    // 合并规格选项
    mergeSpecification,

    // 设置合并列
    calculateSpan,

    // 租金计算
    handleBlur,
    // 分期金额
    onPeriod,
    xgspqd,
    validatePrices,
    // 批量设置sku属性
    onSubmitBatchData,

    // 选择图片
    chooseImg,

    // 图片回调
    imgCallback,

    // 同步规格数据
    syncSpecList,

    // 同步商品详情
    syncProductDetails,

    // 处理商品详情
    handleProductDetails
  }
};
</script>

<style scoped>
.many_table {
  .bg-light-blue {
    background-color: #cad6f1;
  }
}

.hide_border {
  .el-input__inner {
    border-color: transparent;

    &:focus {
      border-color: #75a3ff;
    }
  }
}

.setting-input {
  flex-wrap: wrap;

  .el-input {
    width: 160px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .el-input__inner {
    border-color: #c0c4cc;
  }

  .div {
    margin-top: 5px;
  }
}
</style>

/** * ┌─┐ ┌─┐ + + * ┌──┘ ┴───────┘ ┴──┐++ * │ │ * │ ─── │++ + + + *
███████───███████ │+ * │ │+ * │ ─┴─ │ * │ │ * └───┐ ┌───┘ * │ │ * │ │ + + * │ │
* │ └──────────────┐ * │ │ * │ ├─┐ * │ ┌─┘ * │ │ * └─┐ ┐ ┌───────┬──┐ ┌──┘ + + +
+ * │ ─┤ ─┤ │ ─┤ ─┤ * └──┴──┘ └──┴──┘ + + + + * 兽神保佑 * 代码无BUG! * dhx */



// WEBPACK FOOTER //
// src/views/product/product/part/spec/many/Table.vue